import { useTheme as useMaterialTheme, useMediaQuery } from '@mui/material';
/**
 * Hook to get the current theme.
 */ export const useTheme = ()=>{
    const materialTheme = useMaterialTheme();
    return {
        theme: materialTheme
    };
};
/**
 * A convenience value to allow easy check for whether dark mode is currently in use.
 */ export const useIsDarkMode = ()=>{
    return useTheme().theme.palette.mode === 'dark';
};
/**
 * Does a CSS Media Query and returns true if the user has set a preference
 * for dark mode in their user agent or OS.
 */ export const usePrefersDarkModeMediaQuery = ()=>{
    return useMediaQuery('(prefers-color-scheme: dark)');
};

//# sourceMappingURL=useTheme.js.map